/**
 * @generated SignedSource<<985c24071de00b331f509b39edfb90c9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedHeroCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"RequestMoreImages_user" | "ViewInRoom_user">;
  readonly " $fragmentType": "PdpRespSharedHeroCarousel_user";
};
export type PdpRespSharedHeroCarousel_user$key = {
  readonly " $data"?: PdpRespSharedHeroCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedHeroCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoom_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestMoreImages_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b99f72145ce9d8b7b3b05050133dc373";

export default node;
